import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Introduction() {
  return (
    <section className="intro_section p-100">
      <Container>
        <Row>
          <Col
            xs={12}
            md={12}
            lg={5}
            xl={5}
            xxl={5}
            className="my-auto text-center order-md-1 order-2"
          >
            <StaticImage
              src="../../../images/case-studies/picture-pick/intro_img.webp"
              alt="TekRevol"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={655}
              height={664}
            />
          </Col>
          <Col
            xs={12}
            md={12}
            lg={6}
            xl={6}
            xxl={6}
            className="my-auto  offset-lg-1 order-md-2 order-1"
          >
            <h2 style={{ color: "#000" }}>
              The <span style={{ color: "#F44336" }}>Introduction</span>
            </h2>
            <p>
              Everything begins with a crazy idea. The big idea for Picture Pick
              was to bring together two things that no one could refuse: a
              chance to play an addictive online game, and the opportunity to
              win cash prizes while at it.
            </p>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Introduction;
